import React, { useState } from 'react';
import SortableList from './SortableList';
import { makeOptions, valueEquals } from './utils';
import PropTypes from 'prop-types';
import { SelectSortableBox, SelectBox, StyledSelectContainer, Button, SelectStyles } from './styled';
import Select from 'react-select';
import { find } from 'ramda';

var SelectSortableDefinition = function SelectSortableDefinition(_ref) {
  var items = _ref.items,
      _ref$selected = _ref.selected,
      selected = _ref$selected === undefined ? [] : _ref$selected,
      addHandler = _ref.addHandler,
      removeHandler = _ref.removeHandler,
      sortHandler = _ref.sortHandler,
      selectionHeader = _ref.selectionHeader,
      defaultText = _ref.defaultText,
      noResultsText = _ref.noResultsText;

  var _useState = useState(''),
      currentSelection = _useState[0],
      setCurrentSelection = _useState[1];

  var onAddHandler = function onAddHandler() {
    setCurrentSelection('');
    addHandler({ label: currentSelection });
  };
  var onSelectChange = function onSelectChange(_ref2) {
    var value = _ref2.value;
    return setCurrentSelection(value);
  };
  var options = [{ value: '', label: defaultText }].concat(makeOptions(items, selected));
  var value = find(valueEquals(currentSelection))(options);

  return React.createElement(
    SelectSortableBox,
    null,
    React.createElement(
      SelectBox,
      null,
      React.createElement(
        StyledSelectContainer,
        null,
        React.createElement(Select, { value: value, options: options, onChange: onSelectChange, styles: SelectStyles })
      ),
      React.createElement(
        Button,
        { disabled: !currentSelection, onClick: onAddHandler },
        'ADD'
      )
    ),
    React.createElement(SortableList, {
      label: selectionHeader,
      items: selected,
      onSortEnd: sortHandler,
      removeHandler: removeHandler,
      noResultsText: noResultsText })
  );
};

SelectSortableDefinition.displayName = 'SelectSortableList';
SelectSortableDefinition.propTypes = process.env.NODE_ENV !== "production" ? {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })).isRequired,
  selected: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })),
  addHandler: PropTypes.func,
  removeHandler: PropTypes.func,
  sortHandler: PropTypes.func,
  selectionHeader: PropTypes.string,
  placeholder: PropTypes.string,
  noResultsText: PropTypes.string
} : {};

export default SelectSortableDefinition;